import angular from 'angular';

import Constants from '../config/index';
import NgTracking from 'cars-ng-tracking';
import SponsoredFinanceAd from '../sponsoredFinanceAd/index';

import service from './paymentCalculator.service';
import directive from './paymentCalculator.directive';

export default angular.module('vdp.enhancement.calculator', [
        Constants,
        NgTracking,
        SponsoredFinanceAd
    ])

    .directive('exposedPaymentCalculator', directive)

    .service('loanPaymentService', service)

    .name;